import { render, staticRenderFns } from "./LeaveTypeCreateEditModal.vue?vue&type=template&id=523425a8&scoped=true"
import script from "./LeaveTypeCreateEditModal.vue?vue&type=script&lang=js"
export * from "./LeaveTypeCreateEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523425a8",
  null
  
)

export default component.exports